import React, { useState, useEffect } from "react";
import BottomNavigation from "../Components/BottomNavigation";
import TopNavigation from "../Components/TopNavigation";
import { FiMapPin } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import MessageModal from "../Components/MessageModal";

const PostCreationPage = (location) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");

  const cloudName = "dgd6wt9ni";
  const uploadPreset = "fwbgnido";

  const navigate = useNavigate();

  useEffect(() => {
    if (selectedImage) {
      const reader = new FileReader();
      reader.readAsDataURL(selectedImage);

      reader.onload = (event) => {
        //const base64 = event.target.result.split(",")[1];
        const formData = new FormData();
        formData.append("file", selectedImage);
        formData.append("upload_preset", uploadPreset);

        fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            console.log(data.secure_url);
            setUploadedImageUrl(data.secure_url);
            // do something with the returned image link
          })
          .catch((error) => {
            console.error(error);
          });
      };
    }
  }, [selectedImage]);

  const handleFileChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };

  const [postData, setPostData] = useState({
    restaurantName: "",
    splDish: "",
    img: "",
    rating: "",
    cost: "",
    location: "",
  });

  const handleInputChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value.trim(),
    });
  };

  const [showModal, setShowModal] = useState(false);

  const [msg, setMsg] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    // Check if all fields are filled
    if (
      !postData.restaurantName ||
      !postData.splDish ||
      !postData.rating ||
      !postData.cost ||
      !postData.location
    ) {
      setShowModal(true);
      setTimeout(() => {
        setShowModal(false);
      }, 2000);

      let unfilledFields = [];

      if (!postData.restaurantName) {
        unfilledFields.push("Restaurant Name");
      }
      if (!postData.splDish) {
        unfilledFields.push("Special Dish");
      }
      if (!postData.rating) {
        unfilledFields.push("Rating");
      }
      if (!postData.cost) {
        unfilledFields.push("Cost");
      }
      if (!postData.location) {
        unfilledFields.push("Location");
      }

      setMsg(
        `Please fill in the following fields: ${unfilledFields.join(", ")}`
      );
      return;
    }

    const updatedPostData = { ...postData, img: uploadedImageUrl };

    // Retrieve the token from local storage
    const token = localStorage.getItem("authToken");

    fetch("https://foodie-wirte.onrender.com/api/userpost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatedPostData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Post submitted successfully:", data);
        // Handle any success response or UI updates here
        setPostData({
          restaurantName: "",
          splDish: "",
          rating: "",
          img: "",
          cost: "",
          location: "",
        });

        setSelectedImage(null);

        setUploadedImageUrl("");

        navigate("/");
      })
      .catch((error) => {
        console.error("Error submitting post:", error);
        // Handle any error or display error message here
      });
  };

  const [locationOption, setLocationOption] = useState("");

  useEffect(() => {
    if (location) {
      setLocationOption(location);
    }
  }, [location]);

  console.log("locationOptions: ", locationOption);

  return (
    <div className="min-h-screen">
      <TopNavigation />
      <div className="flex items-center mt-20 ml-4 z-[-1]">
        <FiMapPin className="h-5 w-5 text-red-600 mr-0.5" />
        <span className="text-base mt-0.5 ml-0.5 font-bold text-gray-700 tracking-wide">
          {locationOption.location}
        </span>
      </div>
      <div className="max-w-3xl mx-auto px-4 pt-5 pb-12 mb-10">
        <h2 className="text-xl font-bold mb-4">Create a New Post</h2>
        <div className="flex flex-col md:flex-row">
          <div className="md:w-1/2 pr-8 mb-4 md:mb-0">
            {uploadedImageUrl && (
              <div className="mb-4">
                <h3 className="text-lg font-bold mb-2">Uploaded Image:</h3>
                <img
                  src={uploadedImageUrl}
                  alt="Uploaded"
                  className="max-w-xs"
                />
              </div>
            )}
            <div className="flex flex-col mb-4">
              <label htmlFor="imageInput" className="font-semibold">
                Select an Image:
              </label>
              <input
                id="imageInput"
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                required
                className="border border-red-600 rounded-md px-3 py-2 mt-2 "
              />
            </div>
          </div>
          <div className="md:w-1/2">
            <div className="flex flex-col">
              <label htmlFor="restaurantName" className="font-semibold">
                Restaurant Name:
              </label>
              <input
                id="restaurantName"
                type="text"
                className="border border-gray-300 rounded-md px-3 py-2appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 sm:text-sm"
                required
                value={postData.restaurantName}
                onChange={handleInputChange}
                name="restaurantName"
              />
            </div>
            <div className="flex flex-col mt-4">
              <label htmlFor="splDish" className="font-semibold">
                Special Dish:
              </label>
              <input
                id="splDish"
                type="text"
                className="border border-gray-300 rounded-md px-3 py-2appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 sm:text-sm"
                required
                value={postData.splDish}
                onChange={handleInputChange}
                name="splDish"
              />
            </div>
            <div className="flex flex-col mt-4">
              <label htmlFor="location" className="font-semibold">
                Location:
              </label>
              <input
                id="location"
                type="text"
                className="border border-gray-300 rounded-md px-3 py-2appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 sm:text-sm"
                required
                value={postData.location}
                onChange={handleInputChange}
                placeholder={locationOption.location}
                name="location"
              />
            </div>
            <div className="flex flex-col mt-4">
              <label htmlFor="rating" className="font-semibold">
                Rating:
              </label>
              <input
                id="rating"
                type="number"
                className="border border-gray-300 rounded-md px-3 py-2appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 sm:text-sm"
                required
                placeholder="1.0-5.0"
                value={postData.rating}
                onChange={handleInputChange}
                name="rating"
              />
            </div>
            <div className="flex flex-col mt-4">
              <label htmlFor="cost" className="font-semibold">
                Cost:
              </label>
              <input
                id="cost"
                type="number"
                className="border border-gray-300 rounded-md px-3 py-2appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 sm:text-sm"
                required
                value={postData.cost}
                onChange={handleInputChange}
                name="cost"
              />
            </div>
            <button
              type="submit"
              className="mt-6 bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded"
              onClick={handleSubmit}
            >
              Create Post
            </button>
            {showModal && <MessageModal message={msg} duration={2000} />}
          </div>
        </div>
      </div>
      <BottomNavigation />
    </div>
  );
};

export default PostCreationPage;
